const TimeFormat = {

    toHHMMSS(secs: number) {
        let seconds = Math.floor(secs);
        const hours = Math.floor(seconds / 3600);
        seconds -= hours * 3600;
        const minutes = Math.floor(seconds / 60);
        seconds -= minutes * 60;

        let str = '';
        if (hours < 10) { str += '0'; }
        str += hours + ':';
        if (minutes < 10) { str += '0'; }
        str += minutes + ':';
        if (seconds < 10) { str += '0'; }
        str += seconds;

        return str;
    },

    toTimestampShort(secs: number) {
        let seconds = Math.floor(secs);
        const hours = Math.floor(seconds / 3600);
        seconds -= hours * 3600;
        const minutes = Math.floor(seconds / 60);
        seconds -= minutes * 60;

        let str = '';
        if (hours < 10) { str += '0'; }
        str += hours + ':';
        if (minutes < 10) { str += '0'; }
        str += minutes + ':';
        if (seconds < 10) { str += '0'; }
        str += seconds;

        str = str.replace(/^[:0]+/, '');
        if (!str.includes(':')) {
            if (seconds < 10) {
                str = '0:0' + str;
            } else {
                str = '0:' + str;
            }
        }

        return str;
    },

};

export default TimeFormat;



// WEBPACK FOOTER //
// ./src/lib/TimeFormat.ts